import { getFilterTypeForEditorType } from './filter-type-for-editor-type';

import { TYPE_COLLECTION_FILTER, TYPE_BOOLEAN_FILTER } from '../constants/applied-filter-type';

export const getFilterValueByEditorType = (filter, editorType) => {
  const filterType = getFilterTypeForEditorType(editorType);
  if (filterType === TYPE_BOOLEAN_FILTER) {
    return filter?.value;
  }
  if (filterType === TYPE_COLLECTION_FILTER) {
    return filter?.values || [];
  }
  return filter?.value != null ? String(filter.value) : '';
};
